// removed by extract-text-webpack-plugin
module.exports = {"newsletter-header":"newsletter-header","newsletter-title":"newsletter-title","newsletter-wrapper":"newsletter-wrapper","newsletter-bottom":"newsletter-bottom","newsletter-button-container":"newsletter-button-container","newsletter-button":"newsletter-button"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/newsletters/newsletters.scss
// module id = 4468
// module chunks = 1